import script from "./UserJizenIchiran.vue?vue&type=script&setup=true&lang=js"
export * from "./UserJizenIchiran.vue?vue&type=script&setup=true&lang=js"

import "./UserJizenIchiran.vue?vue&type=style&index=0&id=76666e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76666e4e"]])

export default __exports__